export default [
    {
        path: '/pages/property/activitiesTypeManage',
        meta: { title: '信息大类' },
        name: '/pages/property/activitiesTypeManage',
        component: () => import('@/views/oa/activitiesTypeManageList.vue')
    },
    {
        path: '/pages/property/activitiesManage',
        meta: { title: '信息发布' },
        name: '/pages/property/activitiesManage',
        component: () => import('@/views/oa/activitiesManageList.vue')
    },
    {
        path: '/pages/common/noticeManage',
        meta: { title: '发布公告' },
        name: '/pages/common/noticeManage',
        component: () => import('@/views/oa/noticeManageList.vue')
    },
    {
        path: '/views/oa/addNoticeView',
        name: '/views/oa/addNoticeView',
        component: () => import('@/views/oa/addNoticeViewList.vue')
    },
    {
        path: '/views/oa/editNoticeView',
        name: '/views/oa/editNoticeView',
        component: () => import('@/views/oa/editNoticeViewList.vue')
    },
    {
        path: '/views/oa/noticeDetail',
        name: '/views/oa/noticeDetail',
        component: () => import('@/views/oa/noticeDetailList.vue')
    },
    {
        path: '/pages/complaint/complaintType',
        meta: { title: '投诉类型' },
        name: '/pages/complaint/complaintType',
        component: () => import('@/views/oa/complaintTypeList.vue')
    },
    {
        path: '/views/oa/addComplaintType',
        name: '/views/oa/addComplaintType',
        component: () => import('@/views/oa/addComplaintTypeList.vue')
    },
    {
        path: '/views/oa/editComplaintType',
        name: '/views/oa/editComplaintType',
        component: () => import('@/views/oa/editComplaintTypeList.vue')
    },
    {
        path: '/views/oa/addComplaint',
        name: '/views/oa/addComplaint',
        component: () => import('@/views/oa/addComplaintList.vue')
    },
    {
        path: '/pages/complaint/complaint',
        meta: { title: '投诉建议' },
        name: '/pages/complaint/complaint',
        component: () => import('@/views/oa/complaintList.vue')
    },
    {
        path: '/pages/property/notepadManage',
        meta: { title: '业主反馈' },
        name: '/pages/property/notepadManage',
        component: () => import('@/views/oa/notepadManageList.vue')
    },
    {
        path: '/pages/property/visitManage',
        meta: { title: '访客登记' },
        name: '/pages/property/visitManage',
        component: () => import('@/views/oa/visitManageList.vue')
    },
    {
        path: '/pages/question/questionTitle',
        meta: { title: '问卷题目' },
        name: '/pages/question/questionTitle',
        component: () => import('@/views/oa/questionTitleList.vue')
    },
    {
        path: '/pages/property/questionAnswerManage',
        meta: { title: '问卷调研' },
        name: '/pages/property/questionAnswerManage',
        component: () => import('@/views/oa/questionAnswerManageList.vue')
    },
    {
        path: '/views/oa/addQuestionAnswer',
        name: '/views/oa/addQuestionAnswer',
        component: () => import('@/views/oa/addQuestionAnswerList.vue')
    },
    {
        path: '/views/oa/editQuestionAnswer',
        name: '/views/oa/editQuestionAnswer',
        component: () => import('@/views/oa/editQuestionAnswerList.vue')
    },
    {
        path: '/pages/question/ownerVoting',
        meta: { title: '业主投票' },
        name: '/pages/question/ownerVoting',
        component: () => import('@/views/oa/ownerVotingList.vue')
    },
    {
        path: '/views/oa/addOwnerVoting',
        name: '/views/oa/addOwnerVoting',
        component: () => import('@/views/oa/addOwnerVotingList.vue')
    },
    {
        path: '/views/oa/editOwnerVoting',
        name: '/views/oa/editOwnerVoting',
        component: () => import('@/views/oa/editOwnerVotingList.vue')
    },
    {
        path: '/views/oa/addExamineStaff',
        name: '/views/oa/addExamineStaff',
        component: () => import('@/views/oa/addExamineStaffList.vue')
    },
    {
        path: '/views/oa/editExamineStaff',
        name: '/views/oa/editExamineStaff',
        component: () => import('@/views/oa/editExamineStaffList.vue')
    },
    {
        path: '/pages/property/oaWorkflowManage',
        meta: { title: '流程实例' },
        name: '/pages/property/oaWorkflowManage',
        component: () => import('@/views/oa/oaWorkflowManageList.vue')
    },
    {
        path: '/pages/property/newOaWorkflowManage',
        meta: { title: '我的流程' },
        name: '/pages/property/newOaWorkflowManage',
        component: () => import('@/views/oa/newOaWorkflowManageList.vue')
    },
    {
        path: '/pages/property/newOaWorkflowDoing',
        meta: { title: '工作办理' },
        name: '/pages/property/newOaWorkflowDoing',
        component: () => import('@/views/oa/newOaWorkflowDoingList.vue')
    },
    {
        path: '/pages/property/attendanceClassesManage',
        meta: { title: '考勤班组' },
        name: '/pages/property/attendanceClassesManage',
        component: () => import('@/views/oa/attendanceClassesManageList.vue')
    },
    {
        path: '/pages/attendance/attendanceClassesStaffManage',
        meta: { title: '考勤人员' },
        name: '/pages/attendance/attendanceClassesStaffManage',
        component: () => import('@/views/oa/attendanceClassesStaffManageList.vue')
    },
    {
        path: '/pages/property/todayAttendanceManage',
        meta: { title: '今日考勤' },
        name: '/pages/property/todayAttendanceManage',
        component: () => import('@/views/oa/todayAttendanceManageList.vue')
    },
    {
        path: '/views/oa/addAttendanceClassesStaff',
        name: '/views/oa/addAttendanceClassesStaff',
        component: () => import('@/views/oa/addAttendanceClassesStaffList.vue')
    },
    {
        path: '/pages/property/monthAttendanceManage',
        meta: { title: '月考勤' },
        name: '/pages/property/monthAttendanceManage',
        component: () => import('@/views/oa/monthAttendanceManageList.vue')
    },
    {
        path: '/pages/property/staffAttendanceManage',
        meta: { title: '员工考勤' },
        name: '/pages/property/staffAttendanceManage',
        component: () => import('@/views/oa/staffAttendanceManageList.vue')
    },
    {
        path: '/pages/property/attendanceLogManage',
        meta: { title: '考勤记录' },
        name: '/pages/property/attendanceLogManage',
        component: () => import('@/views/oa/attendanceLogManageList.vue')
    },
    {
        path: '/pages/oa/workType',
        meta: { title: '工作单类型' },
        name: '/pages/oa/workType',
        component: () => import('@/views/oa/workTypeList.vue')
    },
    {
        path: '/pages/oa/startWork',
        meta: { title: '起工作单' },
        name: '/pages/oa/startWork',
        component: () => import('@/views/oa/startWorkList.vue')
    },
    {
        path: '/views/oa/addWork',
        name: '/views/oa/addWork',
        component: () => import('@/views/oa/addWorkList.vue')
    },
    {
        path: '/views/oa/editWork',
        name: '/views/oa/editWork',
        component: () => import('@/views/oa/editWorkList.vue')
    },
    {
        path: '/views/oa/workDetail',
        name: '/views/oa/workDetail',
        component: () => import('@/views/oa/workDetailList.vue')
    },
    {
        path: '/pages/oa/doWork',
        meta: { title: '办工作单' },
        name: '/pages/oa/doWork',
        component: () => import('@/views/oa/doWorkList.vue')
    },
    {
        path: '/pages/oa/copyWork',
        meta: { title: '抄送我的' },
        name: '/pages/oa/copyWork',
        component: () => import('@/views/oa/copyWorkList.vue')
    },
    {
        path: '/pages/oa/workPool',
        meta: { title: '工作单池' },
        name: '/pages/oa/workPool',
        component: () => import('@/views/oa/workPoolList.vue')
    },
    {
        path: '/pages/oa/workDeduction',
        meta: { title: '工作单扣款' },
        name: '/pages/oa/workDeduction',
        component: () => import('@/views/oa/workDeductionList.vue')
    },
    {
        path: '/views/oa/newOaWorkflow',
        name: '/views/oa/newOaWorkflow',
        component: () => import('@/views/oa/newOaWorkflowList.vue')
    },
    {
        path: '/views/oa/newOaWorkflowDetail',
        name: '/views/oa/newOaWorkflowDetail',
        component: () => import('@/views/oa/newOaWorkflowDetailList.vue')
    },
    {
        path: '/views/oa/newOaWorkflowFormEdit',
        name: '/views/oa/newOaWorkflowFormEdit',
        component: () => import('@/views/oa/newOaWorkflowFormEditList.vue')
    },
    {
        path: '/pages/property/simplifyNotepadManage',
        name: '/pages/property/simplifyNotepadManage',
        component: () => import('@/views/oa/simplifyNotepadManageList.vue')
    },
    {
        path: '/pages/complaint/uodoComplaints',
        name: '/pages/complaint/uodoComplaints',
        component: () => import('@/views/oa/uodoComplaintsList.vue')
    },
    {
        path: '/pages/complaint/complaintDetail',
        name: '/pages/complaint/complaintDetail',
        component: () => import('@/views/oa/complaintDetailList.vue')
    },
    {
        path: '/pages/property/visitUndo',
        name: '/pages/property/visitUndo',
        component: () => import('@/views/oa/visitUndoList.vue')
    },
    {
        path: '/pages/complaint/doHistoryComplaints',
        name: '/pages/complaint/doHistoryComplaints',
        component: () => import('@/views/oa/doHistoryComplaintsList.vue')
    },
    {
        path: '/pages/admin/myAuditHistoryOrders',
        name: '/pages/admin/myAuditHistoryOrders',
        component: () => import('@/views/resource/myAuditHistoryOrdersList.vue')
    },
    {
        path:'/pages/property/visitFinish',
        name:'/pages/property/visitFinish',
        component: () => import('@/views/oa/visitFinishList.vue')
        },
    {
        path:'/pages/oa/workTaskDetail',
        name:'/pages/oa/workTaskDetail',
        component: () => import('@/views/oa/workTaskDetailList.vue')
    },
    {
        path: '/views/oa/doCopyWork',
        name: '/views/oa/doCopyWork',
        component: () => import('@/views/oa/doCopyWork.vue')
    }
]